import { Building2, Check } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { STAGES, STAGE_KEYS } from "../lib/constants";
import { useAuth } from "../contexts/AuthContext";

/**
 * Top-level stage switcher in the sidebar. Visible for super_admin/admin always.
 * For other roles with assigned_stages.length > 1, shows only allowed stages.
 */
export default function StageSwitcher() {
  const { user, currentStage, setCurrentStage } = useAuth();
  if (!user) return null;
  const role = user.role;
  const assigned = user.assigned_stages || [];

  const isSuperOrAdmin = role === "super_admin" || role === "admin";
  // Hide if user has 0 or 1 assigned stages and they're not super/admin
  if (!isSuperOrAdmin && assigned.length <= 1) return null;

  const allowed = isSuperOrAdmin && assigned.length === 0 ? STAGE_KEYS : assigned.length ? assigned : STAGE_KEYS;
  const allowAllOption = isSuperOrAdmin;

  return (
    <div className="px-4 pb-3" data-testid="stage-switcher">
      <div className="rounded-lg bg-teal-50/70 border border-teal-200/80 p-2.5">
        <div className="flex items-center gap-1.5 text-[11px] text-teal-700 font-cairo mb-1.5">
          <Building2 size={12} /> المرحلة الحالية
        </div>
        <Select value={currentStage} onValueChange={setCurrentStage}>
          <SelectTrigger className="h-9 bg-white text-sm" dir="rtl" data-testid="stage-switcher-trigger">
            <SelectValue />
          </SelectTrigger>
          <SelectContent dir="rtl">
            {allowAllOption && <SelectItem value="all"><span className="flex items-center gap-2"><Check size={12} /> جميع المراحل</span></SelectItem>}
            {allowed.map(k => <SelectItem key={k} value={k} data-testid={`stage-opt-${k}`}>{STAGES[k]}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
